import React from 'react';
import { ReactComponent as Logo } from './logo.svg';

export default function Header() {
  return (<header className="shadow-md p-4">
    <Logo className="w-32 mb-2" />
    {/* <h1 className="text-gray-200 text-2xl">Tipsy</h1> */}
    {/* <h2 className="text-gray-200 text-xs">Make the most <span role="img" aria-label="beers">🍻</span></h2> */}
  </header>)
}